<template>
  <div>
    <div class="banner">
      <img :src="src.indexOf('http://') == -1 ? 'https://www.itdks.com/' + src : src" alt="">
    </div>
    <div class="cardBox">
      <div class="card" v-for="item in dataList" @click="skip(item)">
        <img :src="showOrg(item, 'img')" alt="">
        <p class="title">{{item.title}}</p>
        <p class="zhubanfang">{{showOrg(item)}}</p>
        <p class="liveTime">时间：{{item.liveTime}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import api from 'api'
  export default {
    name: "topicDt",
    data() {
      return {
        id: '',
        src: '',
            dataList: [], // type 1 直播 2录播
            type: ''
          }
        },
        created() {
          this.id = this.$route.query.id;
          this.initData()
        },
        methods: {
          initData() {
            this.getData()
          },
          async getData() {
            var params = {
              id: this.id
            };
            var res = await api.topic.topicList(params)
            if (res.status == 1) {
              // this.dataList = res.lives
              this.type = res.data.type;
              this.src = res.data.banner;
              this.dataList = res.data.list;
            }
          },
          skip(item) {
            var type = '';
            if (this.type == 1) {
              type='bjy';
              window.location.href='https://www.itdks.com/Home/mobile/detail?id=' + item.id +'&type=' + type
            }
            if (this.type == 2) {
             type = 'normal';
             window.location.href='https://www.itdks.com/Home/mobile/detail?id=' + item.id +'&type=' + type
           }
           if (this.type == 3) {
            type='live';
            window.location.href='https://www.itdks.com/Home/Act/apply?id=' + item.id +'&mUId=' + item.uid
          }
        },
        // 获取并返回组织者信息
        showOrg(item, type) {
          var str = '';
            if (type == 'img') { // 需要返回图片地址
              console.log(item);
              if (item.poster.indexOf('http://') < 0){
                if (item.poster.indexOf('/') == 0) {
                  str = 'https://www.itdks.com' +item.poster
                } else {
                  str = 'https://www.itdks.com/' + item.poster
                }
              }
              else{
                str = item.poster
              }
              // if (item.accountType == 1) {
              //   if (item.sponsor.logo.indexOf('http://') < 0){
              //     if (item.sponsor.logo.indexOf('/') == 0) {
              //       str = 'http://www.itdks.com' +item.sponsor.logo
              //     } else {
              //       str = 'http://www.itdks.com/' + item.sponsor.logo
              //     }
              //   }
              //   else{
              //     str = item.sponsor.logo
              //   }
              // } else {
              //   if (item.teacher.teacherFace.indexOf('http://') < 0){
              //     if (item.teacher.teacherFace.indexOf('/') == 0) {
              //       str = 'http://www.itdks.com'+item.teacher.teacherFace
              //     } else {
              //       str = 'http://www.itdks.com/' + item.teacher.teacherFace
              //     }
              //   }
              //   else{
              //     str = item.teacher.teacherFace
              //   }
              // }
            } else {
              if (item.accountType == 1) {
                str = '主办方 ' + item.sponsor.name
              } else {
                // str = '大咖 ' + item.teacher.teacherName
                str = '主办方 ' + item.sponsor.name
              }
            }
            return str
          }
        }
      }
    </script>

    <style scoped lang="less">
    *{
      margin: 0;
      padding: 0;
    }
    .banner{
      width: 100vw;
      height: 45vw;
      img{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .card{
      width: 100vw;
      height: 30vw;
      position: relative;
      padding-top: 3vw;
      box-sizing: border-box;
      border-bottom: 2px solid #ccc;
      img{
        width: 35vw;
        height: 22vw;
        display: block;
        position: absolute;
        top: 3vw;
        left: 3vw;
      }
      .title{
        width: 55vw;
        font-size: 3.5vw;
        margin-left: 40vw;
        margin-top: 0;
      }
      .zhubanfang, .liveTime{
        width: 53vw;
        font-size: 3.5vw;
        margin-left: 40vw;
        margin-top: 1vw;
        height: 5vw;
        line-height: 6vw;
        overflow: hidden;
        padding-left: 6vw;
      }
      .liveTime{
        background: url("../../assets/img/time_ico.png") no-repeat left center;
        background-size: 4vw 4vw;
      }
      .zhubanfang{
        color: #f3855d;
        background: url('../../assets/img/title_ico.png') no-repeat left center;
        background-size: 4vw 4vw;
      }
    }
  </style>



// WEBPACK FOOTER //
// src/components/topic/topicList.vue